<template>
    <a
        :href="defaultPaymentMethod === 'null' ? checkoutUrl : null"
        @click.prevent="productAction"
        class="product_image">
        <slot></slot>
    </a>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['defaultPaymentMethod']),
        checkoutUrl() {
            let url =
                window.location.origin +
                window.location.pathname +
                '?' +
                window.location.search.substr(1) +
                '&mode=reader&checkout-opened';
            return url;
        },
        productAction() {
            return this.defaultPaymentMethod === 'null' && !this.isIosView
                ? this.openCheckout
                : this.scrollToPaymentBlock;
        },
    },
    methods: {
        openCheckout() {
            this.$store.commit('openCheckout');
            this.tracker.firePixelEvent('checkout_buy_button_is_clicked');
        },
        scrollToPaymentBlock() {
            window.$('html, body').animate(
                {
                    scrollTop: $('.buy-box').offset().top + 150 - $(window).height() / 2,
                },
                300,
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.product_image {
    display: block;
    position: relative;
    aspect-ratio: 128/77;
    width: 768px;
    max-width: 100%;
    margin: 0 auto;
    cursor: pointer;
}
</style>
